import { memo, useState, useEffect } from 'react'
import BaseModal from '@/components/BaseModal/BaseModal'
import BaseTable from '@/components/BaseTable/BaseTable'
import { useUserStore } from '@/hooks/useUserStore'
import { useUserAccount } from '@/hooks/useUserAccount'
import UserAgree from '@/components/UserAgree/UserAgree'
import Privacy from '@/components/Privacy/Privacy'
import { UNIT } from '@/utils/global-const'
import { Button } from 'antd'
import './UserInfo.less'

const columns = [
  {
    title: '支付时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: '16%'
  },
  {
    title: '订单号',
    dataIndex: 'order_no',
    key: 'order_no',
    width: '17%'
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
    width: '11%'
  },
  {
    title: '单价（元）',
    dataIndex: 'unit_price',
    key: 'unit_price',
    width: '11%'
  },
  {
    title: '数量',
    dataIndex: 'count',
    key: 'count',
    width: '8%'
  },
  {
    title: '总价（元）',
    dataIndex: 'price',
    key: 'price',
    width: '10%'
  },
  {
    title: '订单描述',
    dataIndex: 'description',
    key: 'description',
    width: '28%'
  }
]
const columns2 = [
  {
    title: '使用时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: '20%'
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
    width: '12%'
  },
  {
    title: '数量',
    dataIndex: 'count',
    key: 'count',
    width: '12%'
  },
  {
    title: '使用描述',
    dataIndex: 'description',
    key: 'description',
    width: '56%'
  }
]
const UserInfo = ({ visible, onCancel, onOk, logout, handleMenuClick }: any) => {
  const { account, account_list, order_list, usage_list, userInfo } = useUserStore()
  const [xieyi, setXieyi] = useState<boolean>(false)
  const [yinsi, setYinsi] = useState<boolean>(false)
  const { fetchUserAccount } = useUserAccount()
  useEffect(() => {
    fetchUserAccount()
  }, [])
  return (
    <>
      <BaseModal modalProps={{ open: visible, onCancel, onOk }} title={null} className='base-modal-bg-gradien userInfoModal'>
        <div className='user-nav'>
          <div className='left'>
            <img src={userInfo?.headimgurl} alt='用户头像' />
            <label>{userInfo?.nickname}</label>
          </div>
          <div className='right'>
            <label onClick={() => setXieyi(true)}>用户协议</label>
            <label onClick={() => setYinsi(true)}>隐私声明</label>
            <Button type='primary' className={`no-wave-button white-button`} onClick={logout}>
              退出登录
            </Button>
          </div>
        </div>
        <div className='base-modal-section'>
          <ul className='type-list'>
            {account_list.map((item: any, index: number) => {
              return (
                <li key={index} className={`${account?.[item.type] ? 'active' : ''}`}>
                  <p>
                    <label>{item.label}</label>
                    <i className={item.icon} onClick={() => handleMenuClick(0, { key: 'recharge', type: item.type })} />
                  </p>
                  <p>
                    剩余<span>{Number(account?.[item.type] || 0).toLocaleString()}</span>
                    {UNIT[item.type]}
                  </p>
                </li>
              )
            })}
          </ul>
          <h4>我的订单</h4>
          <BaseTable dataSource={order_list} columns={columns} bordered={false} scroll={{ y: 100, x: 'max-content' }} />
          <h4>使用记录</h4>
          <BaseTable dataSource={usage_list} columns={columns2} bordered={false} scroll={{ y: 100, x: 'max-content' }} />
        </div>
      </BaseModal>
      <UserAgree open={xieyi} onCancel={() => setXieyi(false)} />
      <Privacy open={yinsi} onCancel={() => setYinsi(false)} />
    </>
  )
}

export default memo(UserInfo)
